import React from 'react';
import { Outlet } from 'react-router-dom';

import { appConfig } from '@core/config/appConfig';

/**
 * AuthLayout - Para la pantalla de Login.
 * Diseño minimalista centrado.
 */
const AuthLayout = () => {
    return (
        <div className="min-h-screen bg-slate-100 flex items-center justify-center p-6">
            <div className="w-full max-w-lg bg-white rounded-[3rem] shadow-2xl overflow-hidden border border-gray-100 flex flex-col">
                {/* BRANDING HEADER - High Contrast for Logo Visibility */}
                <div className="bg-[#1A1C1E] p-12 flex flex-col items-center justify-center border-b-4 border-accent">
                    <img 
                        src={appConfig.brand.logoFull} 
                        alt={appConfig.brand.logoAlt} 
                        className="h-16 w-auto object-contain drop-shadow-2xl animate-in fade-in zoom-in duration-1000" 
                    />
                </div>

                {/* FORM SECTION */}
                <div className="p-10 md:p-14">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default AuthLayout;
